import { ICONS_ARCADE } from '@/components/Icon'
import { ArcadeBadgeType } from './types'
import { ARCADE_BADGE_TYPES, ARCADE_RANKS } from '@/enum'
import { Rarity } from '@/api/resources/shared/rarity'

export const DEBUG_ARCADE_LEADERBOARD =
  process.env.NEXT_PUBLIC_DEBUG_ARCADE_LEADERBOARD === 'true'

export const ARCADE_LINKS = [
  { label: 'Overview', path: '/arcade' },
  { label: 'Leaderboard', path: '/arcade/leaderboard' },
  { label: 'Prize Wall', path: '/arcade/prize-wall' }
]

export const SEASONS_CLOUDINARY_PATH = 'pages/arcade/seasons/'
export const PRIZEWALL_CLOUDINARY_PATH = 'pages/arcade/seasons/prize-wall/'
export const TEMPORARILY_HARDCODED_SEASON_ID = 1 // @todo - remove this when season gets loaded via GSSP

export const SEASON_PARAM = 'season'
export const ACCOUNT_PARAM = 'account'
export const DETAIL_PARAM = 'detail'

export const RANK_ICONS = {
  [ARCADE_RANKS.Ineligible]: 'trophyIneligible',
  [ARCADE_RANKS.Eligible]: 'trophy'
}

export const arcadeBadgeIcon = (
  type: ArcadeBadgeType
): keyof typeof ICONS_ARCADE => {
  switch (type) {
    case ARCADE_BADGE_TYPES.Eligible:
      return 'trophy'
    case ARCADE_BADGE_TYPES.Ineligible:
      return 'trophyIneligible'
    default:
      return 'joystick'
  }
}

export const ARCADE_INVENTORY_VIEW = {
  inventory: 'inventory',
  converted: 'converted'
} as const

export const ARCADE_RARITY_ITEMS: Record<
  Exclude<Rarity, 'Redeemable' | 'Unique Webbian'>,
  { color: string; label: string }
> = {
  '1 of 1': {
    color: 'bg-white',
    label: '1 of 1'
  },
  Mythic: {
    color: 'bg-rarity-mythic',
    label: 'Mythic'
  },
  Grail: {
    color: 'bg-rarity-grail',
    label: 'Grail'
  },
  Legendary: {
    color: 'bg-rarity-legendary',
    label: 'Legendary'
  },
  Royalty: {
    color: 'bg-rarity-royalty',
    label: 'Royalty'
  },
  Ultra: {
    color: 'bg-rarity-ultra',
    label: 'Ultra'
  },
  Epic: {
    color: 'bg-rarity-epic',
    label: 'Epic'
  },
  Rare: {
    color: 'bg-rarity-rare',
    label: 'Rare'
  },
  Uncommon: {
    color: 'bg-rarity-uncommon',
    label: 'Uncommon'
  },
  Common: {
    color: 'bg-rarity-common',
    label: 'Common'
  },
  Series: {
    color: 'bg-gray-300',
    label: 'Series Coin'
  }
} as const

export const ARCADE_OVERVIEW_BACKGROUND_CLOUDINARY_PATH =
  'pages/arcade/overview/background/'

export const TOP_PLAYERS_THRESHOLD = 3 as const
export const JUMP_TO_RANK_MODAL_ID = 'JUMP_TO_RANK'
export const FIRST_PLACE_RANK = 1 as const
